import { useMemo } from 'react';

import isEqual from 'lodash/isEqual';

import { ListItem, Select, Typography, Box, tokens } from '@cast/design-system';

import { NodeStatusChip } from 'components/chips';
import {
  addSelectedCriterionInAvailableStatuses,
  statusSelectAggregateFn,
} from 'features/cluster/nodes/NodeList/utils';

import {
  useFiltersDropdownAggregate,
  useSearchCriterion,
} from '@cast/shared-search-ui';

export const StatusSelect = () => {
  const criterion = useSearchCriterion('status');

  const { aggregate, dropdownProps } = useFiltersDropdownAggregate(
    'status',
    statusSelectAggregateFn,
    true
  );

  const statuses = useMemo(
    () => addSelectedCriterionInAvailableStatuses(criterion.value, aggregate),
    [aggregate, criterion]
  );

  return (
    <Select
      size="md"
      inputText="Status"
      checkable
      multiple
      value={criterion.value}
      onChange={(option) => {
        if (option?.length) {
          criterion.setValue?.(option);
        } else {
          criterion.clear?.();
        }
      }}
      options={Object.keys(statuses)}
      testId="node-list-status-filter"
      renderOption={(status: string, itemProps) => {
        const count = statuses[status];

        return (
          <ListItem {...itemProps}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              gap="8px"
            >
              <NodeStatusChip
                showTooltip={false}
                status={status}
                sx={{
                  width: '100%',
                  pointerEvents: 'none',
                }}
              />

              <Typography
                variant="P12R"
                color={tokens.theme.fg.structural.secondary}
                width="3ch"
                textAlign="end"
              >
                {count}
              </Typography>
            </Box>
          </ListItem>
        );
      }}
      isOptionEqualToValue={isEqual}
      {...dropdownProps}
    />
  );
};
